if (!customElements.get('ot-collections-hub')) {
  customElements.define('ot-collections-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.queryInput = this.querySelector('[data-collection-query]');
      if (!this.queryInput) return;
      this.initialized = true;
      this.activeGroup = 'all';
      this.clearButton = this.querySelector('[data-collection-clear]');
      this.countElement = this.querySelector('[data-collection-count]');
      this.emptyElement = this.querySelector('[data-collection-empty]');
      this.filterButtons = Array.from(this.querySelectorAll('[data-collection-filter]'));
      this.items = Array.from(this.querySelectorAll('[data-collection-item]')).map(element => ({
        element,
        name: this.normalize(element.dataset.collectionName),
        group: element.dataset.collectionGroup
      }));
      this.filterButtons.forEach(button => button.addEventListener('click', () => {
        this.activeGroup = button.dataset.collectionFilter;
        this.filter();
      }));
      this.queryInput.addEventListener('input', () => this.filter());
      this.queryInput.addEventListener('search', () => this.filter());
      this.queryInput.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.reset();
      });
      this.clearButton.addEventListener('click', () => {
        this.queryInput.value = '';
        this.filter();
        this.queryInput.focus();
      });
      this.querySelector('[data-collection-reset]').addEventListener('click', () => this.reset());
      this.setAttribute('data-enhanced', '');
      this.filter();
    }
    normalize(value) {
      return String(value || '').normalize('NFKD').replace(/×/g, 'x').toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
    }
    filter() {
      const query = this.normalize(this.queryInput.value);
      let visibleCount = 0;
      this.items.forEach(item => {
        const matches = item.name.includes(query) && (this.activeGroup === 'all' || item.group === this.activeGroup);
        item.element.hidden = !matches;
        if (matches) visibleCount += 1;
      });
      this.filterButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.collectionFilter === this.activeGroup)));
      this.clearButton.hidden = !query;
      this.countElement.textContent = String(visibleCount);
      this.emptyElement.hidden = visibleCount !== 0;
    }
    reset() {
      this.queryInput.value = '';
      this.activeGroup = 'all';
      this.filter();
      this.queryInput.focus();
    }
  });
}
